module.exports = __webpack_public_path__ + "img/40_38_079_750.74c57329.jpg";